import axios from 'axios'

export function getLatestTos() {
  return axios.get(`/api/terms-of-service/latest`)
}
